import React,{useState,useRef,useCallback,useContext  } from "react";
import {
    Dropdown,
    TooltipHost,
    PrimaryButton,
    ContextualMenu,
    IconButton,
    Stack,
    Icon,
    Spinner,
    SpinnerSize,
  } from "@fluentui/react";
import themeContext from "../../../../context/theme/ThemeContext";
import studylistContext from "../../../../context/studylist/StudylistContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";

const SuperAdminContextMenu = (props) => {

    const linkRefContext = useRef(null);

    const item = props.item;
    const [clickInsideContextMenu, setClickInsideContextMenu] = useState(false);
    const { themeName } = useContext(themeContext);
    const {
        dataQueryState,
        setDataQueryState,
        studyListLoading,
        setStudyListLoading,
        studyListRef,
        showClientName,
        updateLockUnlockRows,
        menuForClosedAndReverted,
        setRefreshRequired,
        refreshRequired,
        setResetRowSelection,
      } = useContext(studylistContext);

    const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);

    const contextMenuStyle = {
        root: {
          backgroundColor: `${
            themeName != "light"
              ? "#201F1E"
              : "white"
          }`,
          left: "0",
        },
        calloutMain: {
          borderRadius: "7px !important",
        },
        rootHovered: {
          color: "white",
        },
      };

    const onHideContextualMenu = useCallback((index) => {
        // props.setShowContxtMenuForChain(() => {
        //   const newItem = { ...props.showContxtMenuForChain };
        //   newItem[index] = false;
        //   return newItem;
        // });
      }, []);


  return menuForClosedAndReverted(
    item?.closed != 0 && item?.reportDoneStatus != 2,
    item?.closed == item?.firmId,
    setAlertSuccessModal,
    alertSuccessModal,
    item,
    props.handleRevertCloseStudyModal,
    props.handleSendReport
  ).length > 0 ? (
    <div
      ref={linkRefContext}
      style={{
        display: "flex",
        alignItems: "center",
        marginLeft: "18px",
      }}
    >
      {" "}
      {/* <MoreIcon active={false} /> */}
      <IconButton
        iconProps={{ iconName: "MoreCustomIcon" }}
        iconName="more"
        onClick={() => {
          setClickInsideContextMenu(true);
          props.handleContextMenuClick(props.getStatusOfClosedStudy());
        }}
        style={{
          color: "#8A8886",
          border: "none",
          outline: "none",
        }}
      />
      {clickInsideContextMenu && (
        <ContextualMenu
          styles={contextMenuStyle}
          items={menuForClosedAndReverted(
            item?.closed != 0 && item?.reportDoneStatus != 2,
            item?.closed == item?.firmId,
            setAlertSuccessModal,
            alertSuccessModal,
            item,
            props.handleRevertCloseStudyModal,
            props.handleSendReport
          )}
          //hidden={!showContextCXRMenu}
          target={linkRefContext}
          // onMouseEnter={(e)=>{
          //     setContextCXRMenu(true)
          // }}
          ref={props.menuRef}
          onItemClick={(e) => {
            console.log("--- Item Clicked");
            setClickInsideContextMenu(false);
          }}
          onDismiss={(e) => {
            console.log("--- Item Dismiss");
            setClickInsideContextMenu(false);
          }}
        />
      )}
    </div>
  ) : (
    <></>
  );
};

export default SuperAdminContextMenu;
